import Snackbar from "../snackbar/Snackbar";
import {ErrorTranslationKey} from "../ErrorTranslationKey";
import {t} from "../../../../store/localization/TranslMessasge";
import {DataTypeTranslationKey} from "./DataTypeTranslationKey";
import DeleteConfirmationDialog from "../../../../components/dialogs/DeleteConfirmationDialog";
import {DataTypeApiClient, DataTypeErrorCode} from "../../../../common/apis/datatype/DataTypeApiClient";
import {useRef, useState} from "react";
import {AjaxError} from "rxjs/ajax";
import {ValidationError} from "../../../../common/ValidationError";

export interface DataTypeDeleteDialogProps {
    open: boolean;
    dataTypeDefinitionId: string;
    onClose: () => void;
    onDeleted: () => void;
}

export default function DataTypeDeleteDialog(props: Readonly<DataTypeDeleteDialogProps>) {
    const {open, dataTypeDefinitionId, onClose, onDeleted} = props;

    const dataTypeApiClient = useRef(new DataTypeApiClient());
    const [errorMessage, setErrorMessage] = useState<string | undefined>();
    const [deleteInProgress, setDeleteInProgress] = useState<boolean>(false);

    function deleteDefinition(dataTypeDefinitionId: string) {
        setDeleteInProgress(true);
        dataTypeApiClient.current.delete(dataTypeDefinitionId)
            .then(() => {
                onDeleted();
                onClose();
                Snackbar.success(t(DataTypeTranslationKey.DATA_TYPE_DELETED_SUCCESSFULLY));
            })
            .catch((error: AjaxError | ValidationError) => {
                if (error instanceof ValidationError && error.error.code === DataTypeErrorCode.DATA_TYPE_IS_IN_USE) {
                    setErrorMessage(t(DataTypeTranslationKey.DATA_TYPE_IS_IN_USE_BY_ATTRIBUTES_IN_STEREOTYPES));
                } else {
                    Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error);
                }
            })
            .finally(() => setDeleteInProgress(false));
    }

    if (!dataTypeDefinitionId) {
        return null;
    }

    return (
        <DeleteConfirmationDialog
            open={open}
            title={t(DataTypeTranslationKey.DELETE_DATA_TYPE_PROMPT)}
            confirmationText={t(DataTypeTranslationKey.DATA_TYPE_WILL_BE_DELETED)}
            errorText={errorMessage}
            deleteDisabled={deleteInProgress || errorMessage !== undefined}
            onDelete={() => deleteDefinition(dataTypeDefinitionId)}
            onClose={onClose}/>
    );
}
